var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxcsoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 40,
    rx: 4,
    fill: "#1a237e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 27,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "IXC Soft")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxcsoft);
export default __webpack_public_path__ + "static/media/ixcsoft.163871fb95d72194ba9f5f6aae40610a.svg";
export { ForwardRef as ReactComponent };